import { render, staticRenderFns } from "./InvestorBiodata.vue?vue&type=template&id=5f070460"
import script from "./InvestorBiodata.vue?vue&type=script&lang=js"
export * from "./InvestorBiodata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports